import React from "react";
import styled from "styled-components";
import about from "../assets/about.jpg"
import colors from "../utils/colors";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
  max-width: 1180px;
  margin: 5.5rem auto 3rem; 
  padding: 0 clamp(1rem, 4vw, 4rem);
  min-height: 70vh;

  @media screen and (max-width:770px) {
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 5rem;
  }
`;

const TextContainer = styled.div`
  flex: 1; 
  padding: 0; 
  
  @media screen and (max-width:770px) {
    flex: 2; 
    padding: 0 20px; 
    margin-right: 0;
  }
`;

const ImageContainer = styled.div`
  flex: 1;

  img {
    width: 100%; 
    height: 28rem;
    object-fit: cover;
    border-radius: 0.9rem;
    box-shadow: 0 1rem 2rem rgba(69, 90, 100, 0.16);
  }

  @media screen and (max-width:770px) {
    img {
      width: 100%; 
      height: 18rem;
      margin-left: 0;
    }
  }
`;

const Title = styled.h2`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: ${colors.background};
  line-height: 1.1;
  
  @media screen and (max-width:770px) {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
  }
`;

const Paragraph = styled.p`
  font-size: 1rem;
  text-align: justify;
  color: ${colors.darkColor};
  line-height: 1.8;

  @media screen and (max-width:770px) {
    font-size: 0.8rem;
    margin-bottom: 0.6rem;
  }
`;

function AboutUs() {
  return (
    <Container>
      <TextContainer>
        <Title>
            Nous sommes une équipe passionnée de prestation de divers services.
        </Title>
        <Paragraph>
            Notre société, ROMS, se spécialise dans une gamme étendue de services incluant la gestion économique, les finances, la comptabilité, l'import-export, la consultation, et bien d'autres domaines. Nous nous engageons à fournir à nos clients des solutions sur mesure et efficaces, adaptées à leurs besoins spécifiques. Notre objectif est d'accompagner nos clients dans la réalisation de leurs objectifs commerciaux en leur offrant un soutien fiable et professionnel.
        </Paragraph>
      </TextContainer>
      <ImageContainer>
        <img src={about} alt="Une personne" />
      </ImageContainer>
    </Container>
  );
}

export default AboutUs
